class EventDetail {
	constructor(element) {
        this.el = element;
        this.init();
    }

    init() {
    	this.loadMore();
    }

    loadMore() {
    	this.el.addEventListener("click", (event) => {
            this.el.style.display = 'none';
        });
    }

}

document.addEventListener("DOMContentLoaded", () => {
    const element = document.querySelector(".sectionLoadMore");

    if (element) {

        new EventDetail(element);
    }
});